export default __webpack_public_path__ + "static/remedies-370252b1954baa32d3a30bd1e2c77c92.png";